import React from 'react'

const JS_Essential_Mock_Coding_Test_1 = () => {
  return (
    <div>
      <h1>Mock Test 1</h1>
    </div>
  )
}

export default JS_Essential_Mock_Coding_Test_1
